import type { LevelCatalog, OfferView } from "@highmarch/app";
import { offersAllowed } from "@highmarch/domain";
import { btnHtml, fmtCompact } from "../kit";
import { uiUrl } from "../portraits";
import { dealsLink } from "../deals/dealsLink";
import { openDeals } from "../deals/dealsSheet";
import { gemIcon } from "./econArt";
import "../styles/offerTriggers.css";

/**
 * The Welcome Back pack beside the welcome-back gift on the check-in card (MONETISATION_PLAN MP-05): a card in the gift's
 * own style (its blue plate), naming the pack beside its Deals tab's painted gift crate (icons/deals_welcome.png), with
 * one blue "See" that opens Deals on its page — the purchase happens there, with its price, value and Bram. Shown only
 * in the hub, with a store, outside the quiet after a loss, while the pack is on sale (its window after the return).
 * Seeing it here counts as seeing its badge.
 */

/** The Welcome Back pack as on sale now, or null where none may be shown. */
function packOnSale(catalog: LevelCatalog, now: number): OfferView | null {
  const l = dealsLink();
  if (!l || !l.hub || !offersAllowed(catalog.balance, "hub", now, catalog.economy.shop.lastLossAt)) return null;
  catalog.offerTriggers.refresh(now);
  const page = catalog.balance.offers.pages.find((p) => p.offers.some((o) => o.welcomeBack));
  const offer = page?.offers.find((o) => o.welcomeBack);
  return offer ? catalog.deals.view(offer.id, now, l.ctx()) : null;
}

/** The card's markup ("" when the pack is not on sale); its suggestion counts as seen. */
export function welcomePackHtml(catalog: LevelCatalog, now: number): string {
  const v = packOnSale(catalog, now);
  if (!v) return "";
  const l = dealsLink()!;
  if (catalog.offerTriggers.viewed(v.pageId, now, l.ctx())) l.changed();
  const gems = v.items.reduce((n, i) => n + (i.kind === "gems" ? i.amount : 0), 0);
  return `<div class="welcome wpack"><b>${v.name}</b>
    <div class="sr"><img decoding="sync" class="wpart" src="${uiUrl("icons/deals_welcome.png")}" alt=""><span class="rw gm">${gemIcon(15)}${fmtCompact(gems)}</span>${btnHtml("See", "blue", { className: "wpackgo", iconRight: "chev", data: `data-page="${v.pageId}"` })}</div></div>`;
}

/** "See": Deals on the pack's page, over the check-in card (which stays to be claimed). */
export function bindWelcomePack(sheet: HTMLElement): void {
  const b = sheet.querySelector<HTMLButtonElement>(".wpackgo");
  if (b) b.onclick = () => { if (!openDeals({ page: b.dataset.page ?? null })) b.disabled = true; };
}
